export enum ContactType {
  PHONE,
  EMAIL,
  MESSAGE,
}
